import { createInstance } from "i18next";
import type { InitOptions } from "i18next";
import {
    address,
    broadbandLogin,
    cart,
    common,
    confirmation,
    control,
    customerDetails,
    eSim,
    footer,
    glossary,
    header,
    home,
    installation,
    marketingPreferences,
    portin,
    selectReason,
    summary,
    validation,
} from "./en/translate";
import { centsToPrice } from "itsf-ui-common";
import { detectBrowserLanguage } from "@utils/i18n";

export const defaultNS = "common";

export const resources = {
    en: {
        address,
        broadbandLogin,
        cart,
        confirmation,
        common,
        control,
        customerDetails,
        footer,
        glossary,
        header,
        home,
        marketingPreferences,
        portin,
        selectReason,
        summary,
        validation,
        eSim,
        installation,
    },
} as const;

const i18nOptions: InitOptions = {
    lng: detectBrowserLanguage(),
    fallbackLng: "en",
    ns: [
        "address",
        "broadbandLogin",
        "cart",
        "confirmation",
        "common",
        "customerDetails",
        "footer",
        "glossary",
        "header",
        "home",
        "marketingPreferences",
        "portin",
        "selectReason",
        "summary",
        "validation",
        "eSim",
        "installation",
    ],
    defaultNS,
    fallbackNS: "common",
    interpolation: {
        format: (value, format) => {
            if (format === "priceFormat") {
                return `€${centsToPrice(value)}`;
            }

            return value ? value.toString() : "";
        },
        escapeValue: false,
    },
    resources,
    debug: process.env.environment === "development",
    react: {
        useSuspense: false,
    },
};

const i18n = createInstance();

i18n.init(i18nOptions);

export { i18n };
